import React, {useState} from "react";
import {BemViver} from "../assets/images";
import {BrowserRouter, Route} from "react-router-dom";
import {BaseLayout} from "../components/BaseLayout";
import {PropositionsApp} from "../pages/PropositionsApp/PropositionsApp";
import {ErrorBoundaryRoutes} from "../components/ErrorBoundaryRoutes";
import HomeApp from "../pages/HomeApp/HomeApp";
import {TopBar} from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import {DrawerHeader} from "../components/DrawerHeader";
import {CssBaseline} from "@mui/material";
import DrawerContextProvider from "../contexts/DrawerContext";
import TopBarContextProvider from "../contexts/TopBarContext";
import {DashboardApp} from "../pages/DashboardApp/DashboardApp";

export function NavigationRoot() {

    const [open, setOpen] = useState(false);

    const handleToggleDrawer = () => {
        setOpen(!open);
    };

    const [title, setTitle] = useState("Admin do Bem Viver Pernambuco")

    return (<BrowserRouter>
        <CssBaseline/>
        <DrawerContextProvider open={open} handleToggleDrawer={handleToggleDrawer}>
            <TopBarContextProvider title={title} setTitle={setTitle}>
                <TopBar/>
                <ErrorBoundaryRoutes>
                    <Route element={<BaseLayout/>}>
                        <Route path="/" element={<HomeApp/>}/>
                        <Route path="/propostas/*" element={<PropositionsApp/>}/>
                        <Route path="/dashboard" element={<DashboardApp/>}/>
                    </Route>
                </ErrorBoundaryRoutes>
            </TopBarContextProvider>
        </DrawerContextProvider>
    </BrowserRouter>)

}